import React from "react";
import styled from "styled-components";
import {useAtomValue} from "jotai";
import {
  stepCampaignAtom
} from "../../pages/campaign/entity";

const CAMPAIGN_STEPS = [
  {
    step: 0,
    number: 1,
    label: "기본 정보"
  },
  {
    step: 1,
    number: 2,
    label: "예산 설정"
  },
  {
    step: 2,
    number: 3,
    label: "타겟팅"
  },
  {
    step: 3,
    number: 4,
    label: "소재 설정"
  }
];

export default function CampaignStepNavigator() {
  const stepCampaign =
      useAtomValue(stepCampaignAtom);

  const currentStep =
      stepCampaign?.steps ?? 0;

  const completedAll =
      currentStep >= 4;

  return (
      <StepContainer
          aria-label="캠페인 생성 단계"
      >
        {CAMPAIGN_STEPS.map(
            (item, index) => {
              const active =
                  !completedAll &&
                  currentStep === item.step;

              const completed =
                  completedAll ||
                  currentStep > item.step;

              return (
                  <React.Fragment
                      key={item.step}
                  >
                    <StepItem
                        $active={active}
                        title={`${item.number}. ${item.label}`}
                        aria-current={
                          active
                              ? "step"
                              : undefined
                        }
                    >
                      <StepCircle
                          $active={active}
                          $completed={completed}
                      >
                        {completed
                            ? "✓"
                            : item.number}
                      </StepCircle>

                      <StepLabel
                          $active={active}
                          $completed={completed}
                      >
                        {item.label}
                      </StepLabel>
                    </StepItem>

                    {index <
                        CAMPAIGN_STEPS.length -
                        1 && (
                            <StepLine
                                $completed={
                                    completedAll ||
                                    currentStep >
                                    item.step
                                }
                                aria-hidden="true"
                            />
                        )}
                  </React.Fragment>
              );
            }
        )}
      </StepContainer>
  );
}

const StepContainer = styled.ol`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 7px 11px;
  border-radius: 7px;
  list-style: none;

  @media (max-width: 720px) {
    padding: 6px 8px;
  }
`;

const StepItem = styled.li`
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 0 0 auto;
`;

const StepCircle = styled.span`
  display: inline-flex;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border: 1px solid
  ${({$active, $completed}) =>
          $active || $completed
                  ? "#f5811f"
                  : "#d1d1d1"};
  border-radius: 50%;
  background-color:
          ${({$active, $completed}) => {
            if ($active) {
              return "#f5811f";
            }

            if ($completed) {
              return "#fff4e8";
            }

            return "#fff";
          }};
  color:
          ${({$active, $completed}) => {
            if ($active) {
              return "#fff";
            }

            if ($completed) {
              return "#f5811f";
            }

            return "#999";
          }};
  font-size: 12px;
  font-weight: 700;
`;

const StepLabel = styled.span`
  color:
          ${({$active, $completed}) => {
            if ($active) {
              return "#f5811f";
            }

            if ($completed) {
              return "#555";
            }

            return "#999";
          }};
  font-size: 12px;
  font-weight:
          ${({$active}) =>
                  $active
                          ? 700
                          : 500};
  white-space: nowrap;

  @media (max-width: 1100px) {
    display: none;
  }
`;

const StepLine = styled.span`
  width: 18px;
  height: 1px;
  margin: 0 6px;
  background-color:
          ${({$completed}) =>
                  $completed
                          ? "#f5811f"
                          : "#dddddd"};

  @media (max-width: 720px) {
    width: 10px;
    margin: 0 4px;
  }
`;